<template>
  <div
    ref="eventDiv"
    class="calendar-event full-width"
    data-cy="calendar-event"
    :data-test-id="`calendar-event-${event.title}`"
  >
    <TruncateText :expand="false">
      <i :class="iconClasses" />

      <span v-if="!calendarEvent.exclusive" class="available-badge">
        AVAILABLE
      </span>
      <span class="link">{{ event.title }}</span>
    </TruncateText>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";

import TruncateText from "@/components/TruncateText.vue";
import { CalendarEvent } from "@/typings/calendarEvent";

const props = defineProps({
  event: {
    type: Object as () => {
      title: string;
      extendedProps: {
        event: CalendarEvent;
      };
    },
    default: null
  }
});

const eventDiv = ref<Element | null>(null);

const calendarEvent = computed(() => props.event?.extendedProps.event);

const iconClasses = computed(() => {
  const classes = ["fa-regular", "text-link"];

  classes.push(
    calendarEvent.value.exclusive ? "fa-calendar-xmark" : "fa-calendar-check"
  );

  return classes;
});

onMounted(() => {
  tippy(eventDiv.value!.parentElement, { content: props.event.title });
});
</script>

<style lang="scss" scoped>
.available-badge {
  font-weight: 600;
  border-radius: 4px;
  background: var(--neutral-gray-100);
  padding: 1px;
  font-size: 0.8em;
  color: var(--font-title-color) !important;
  height: 15px;
  text-align: center;
  padding-right: 0px;
  margin-right: 5px;
  position: relative;
  top: -1px;
  text-shadow: none !important;
}
</style>
